import { useState } from 'react';
import { Formik, Form } from 'formik';
import {Button, Callout, Tooltip} from '@neshane/blueberry';
import { fromAxiosError } from '../../../../api';
import { QueryError } from '../../../../common/components';
import { postApiAdminAuthLogin } from '../../../../generated/apiClient';
import { adminLoginSchema } from '../../../../common/validation';
import { useAuth } from '../../hooks';
import { AuthLayout } from '../AuthLayout';
import UsernameInput from './UsernameInput';
import PasswordInput from './PasswordInput';

/**
 * Admin Login Form Component
 * Uses HttpOnly cookie auth - backend sets staff_access_token, returns { success, admin }
 */
function AdminLoginForm({ onLogin }) {
    const { login } = useAuth();
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleAdminLogin = async (values, { setSubmitting }) => {
        try {
            setError(null);
            setLoading(true);

            const response = await postApiAdminAuthLogin({
                username: values.username,
                password: values.password,
            });

            const adminData = response.admin || response.data?.admin;
            if ((response.success || adminData) && adminData) {
                // useAuth.login handles both token+user and user-only (cookie auth)
                await login(adminData, adminData);
                onLogin(adminData);
            } else {
                setError(response.error || response.message || 'Login failed');
                setLoading(false);
                setSubmitting(false);
            }
        } catch (err) {
            console.error('Admin login error:', err);
            setError(await fromAxiosError(err));
            setLoading(false);
            setSubmitting(false);
        }
    };

    return (
        <AuthLayout title="ورود مدیر" subtitle="برای دسترسی به پنل مدیریت، وارد شوید">
            {error &&
                (typeof error === 'string' ? (
                    <Callout variant="alert" title={error} iconName="triangle-warning" />
                ) : (
                    <QueryError componentType="Callout" queryError={error} />
                ))}

            <Formik
                initialValues={{ username: '', password: '' }}
                validationSchema={adminLoginSchema}
                onSubmit={handleAdminLogin}
            >
                {({ isSubmitting, isValid }) => (
                    <Form>
                        <UsernameInput
                            disabled={loading || isSubmitting}
                            autoFocus
                        />

                        <Tooltip content="لطفا این فیلد را پر کنید"><div style={{width:"100%"}}><PasswordInput
                            disabled={loading || isSubmitting} required /></div></Tooltip>

                        <Button
                            type="submit"
                            variant="primaryBrand"
                            text={loading || isSubmitting ? 'در حال ورود...' : 'ورود'}
                            isLoading={loading || isSubmitting}
                            disabled={loading || isSubmitting || !isValid}
                            fit="parent"
                        />
                    </Form>
                )}
            </Formik>
        </AuthLayout>
    );
}

export default AdminLoginForm;
